import { makeStyles } from 'tss-react/mui';
import Avatar from '@mui/material/Avatar';
import { momentParse } from '../../utils/time';
import MaterialLink from '../material-link';
import type { GroupComment as GroupCommentType } from '../../types/GroupComment';
import type { GroupPost } from '../../types/GroupPost';
import { useAppContext } from '../../contexts/app';
import DeletePostCommentLink from './delete-post-comment-link';
import Markdown from '../markdown';

const useStyles = makeStyles()((theme) => ({
  comment: {
    margin: theme.spacing(1, 0),
  },
  meta: {
    display: 'flex'
  },
  avatarLink: {
    marginRight: theme.spacing(1)
  },
  displayName: {
  },
  subName: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: theme.palette.text.primary
  },
  createdAt: {
  },
  deleteLink: {
    marginLeft: theme.spacing(1),
    '& > button': {
      paddingBottom: 2
    }
  },
  body: {
    margin: theme.spacing(2, 0, 2, 0),
  },
}));

type Props = {
  comment?: GroupCommentType;
  groupPost?: GroupPost;
};

const GroupComment = ({ comment, groupPost }: Props) => {
  const { isLoggedIn } = useAppContext();
  const { classes } = useStyles();
  const createdAt = momentParse(comment.createdAt);
  return (
    <div className={classes.comment}>
      <div className={classes.meta}>
        <MaterialLink
          href={`/people/${comment.user.username}`}
          className={classes.avatarLink}
        >
          <Avatar
            alt={comment.user.displayName}
            src={comment.user.avatar.small.url}
          />
        </MaterialLink>
        <div className={classes.displayName}>
          <MaterialLink
            href={`/people/${comment.user.username}`}
          >
            {comment.user.displayName}
          </MaterialLink>
          <div className={classes.subName}>
            <time
              className={classes.createdAt}
              dateTime={createdAt.toString()}
              title={createdAt.format('dddd, MMMM Do, YYYY h:mm a')}
            >
              {createdAt.fromNow()}
            </time>
            {isLoggedIn && (
              <DeletePostCommentLink comment={comment} groupPost={groupPost} />
            )}
          </div>
        </div>
      </div>
      <div className={classes.body}>
        <Markdown>{comment.body}</Markdown>
      </div>
    </div>
  );
};

export default GroupComment;
